import type { WireCommand } from "../protocol/protocol";

/**
 * The commands the composer's menu offers for `text`: open only while the whole text is a "/"
 * and the start of a command's name (no space, no files), so "/usr/bin" or "see /clear" never
 * opens it and the text is left as typed.
 */
export function matchingCommands(commands: WireCommand[], text: string): WireCommand[] {
  if (!text.startsWith("/") || /\s/.test(text)) return [];
  return commands.filter((command) => command.name.startsWith(text));
}
